import { render, staticRenderFns } from "./ListHomeworkStudentV2.vue?vue&type=template&id=1370ca5a&scoped=true"
import script from "./ListHomeworkStudentV2.vue?vue&type=script&lang=js"
export * from "./ListHomeworkStudentV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1370ca5a",
  null
  
)

export default component.exports